export class TitleService {
    $document;
    stateService;
    DEFAULT_TITLE = 'Threema Web';
    title;
    unreadCount = 0;
    static $inject = ['$document', 'StateService'];
    constructor($document, stateService) {
        this.$document = $document;
        this.stateService = stateService;
        this.stateService.evtUnreadCountChange.attach((count) => {
            this.unreadCount = count;
            this.update();
        });
        this.update();
    }
    update() {
        if (this.unreadCount > 0) {
            this.title = `(${this.unreadCount}) ${this.DEFAULT_TITLE}`;
        }
        else {
            this.title = this.DEFAULT_TITLE;
        }
        this.$document[0].title = this.title;
    }
}
